<div class="row justify-content-center">
  <div class="col-auto m-4">
    <div class="login-container">
      <div class="row justify-content-center mb-4">
        <div class="col-auto d-flex">
          <div class="form-header">
            <h2>Preparing Demo Portal</h2>
            <div class="form-header-description" *ngIf="!showWarning">
              We are currently validating your demo portal code. <br />
              You'll be redirected to the demo portal within couple of seconds.
            </div>
            <div
              class="form-header-description text-danger"
              *ngIf="showWarning"
            >
              Validation Fail! The provided code is not valid.
              <ul class="mt-2">
                <li *ngFor="let error of errors" class="demo-portal-error mt-1">
                  {{ error }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
